/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Autocomplete,
  Box,
  FormControl,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Divider,
  Typography,
  IconButton,
} from "@mui/material";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MyHeader, TextFieldWrapper } from "../StyledComponent";
import AdminCheckBox from "../StyleComponents/AdminCheckBox";
import {
  EditUserInfo,
  GetSupervisor,
  GetSupervisorSRM,
  getCityList,
  getStateList,
  get_user,
} from "../../Services/Services";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../store/action/action";
import SuperAdminHamburgerMenu from "./SuperAdminHamburgerMenu";
const initialState = {
  code: "123456",
  name: "",
  email: "",
  role: [],
  mobile: "",
  supervisor: "",
  state: "",
  city: "",
};

function ViewUser() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formVal, setFormVal] = useState(initialState);
  const dispatch = useDispatch();
  const [error, setError] = useState({});
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const [disable, setDisable] = useState({
    manager: false,
    srManager: false,
    admin: false,
    BUH: false,
    finance: false,
  });

  const superVisor = [
    "Admin",
    "Finance",
    "BUH",
    "Operations",
    "Senior_Manager",
    "Manager",
  ];

  const [supervisorArray, setsupervisorArray] = useState([]);
  const [formError, setformError] = useState({});

  function validate(e) {
    const error = {};
    if (e.target.value < 1 && e.target.name === "code") {
      error.code = "Emp.code Required!";
    } else if (
      e.target.value.length !== 0 &&
      e.target.value.length < 4 &&
      e.target.name === "name"
    ) {
      error.name = "Name must be of 4 character.";
    } else if (
      e.target.value.length !== 0 &&
      e.target.value.length < 10 &&
      e.target.name === "mobile"
    ) {
      error.mobile = "Mobile Number Not Valid.";
    } else if (
      !e.target.value.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ) &&
      e.target.value.length > 0 &&
      e.target.name === "email"
    ) {
      error.email = "Please Enter Valid Email !!";
    }
    setformError((old) => ({ ...old, [e.target.name]: error[e.target.name] }));
  }

  async function getSupervisor(role) {
    let superVisor1 = [
      "Finance",
      "Operations",
      "BUH",
      "Senior_Manager",
      "Manager",
      "Role",
    ];

    let finalQuerry = [];
    if (role.includes("Manager")) {
      finalQuerry = ["Senior_Manager"];
    } else if (role.includes("Senior_Manager")) {
      finalQuerry = ["BUH"];
    } else if (role.includes("BUH")) {
      finalQuerry = ["Operations"];
    } else if (role.includes("Operations")) {
      finalQuerry = ["BUH"];
    } else if (role.includes("Admin")) {
      finalQuerry = ["BUH"];
    } else if (role.includes("Finance")) {
      finalQuerry = ["Role"];
    }
    superVisor1 = superVisor1.filter((row) => {
      return finalQuerry.includes(row);
    });

    if (role.includes("Manager")) {
      const supervisor = await GetSupervisor({
        role: superVisor1,
        state,
        city,
      });
      setsupervisorArray(supervisor.data);
    } else if (
      role.includes("Senior_Manager") ||
      role.includes("Operations") ||
      role.includes("BUH") ||
      role.includes("Admin")
    ) {
      const supervisor = await GetSupervisorSRM(superVisor1);
      setsupervisorArray(supervisor.data);
    }
  }

  function manageRole(role) {
    let setVal = {};
    if (
      (role.includes("Manager") || role.includes("Operations")) &&
      role.length > 0
    ) {
      superVisor.map(
        (row) =>
          (setVal = {
            ...setVal,
            [row]: true,
            Admin: false,
            Operations: !role.includes("Operations"),
            Manager: !role.includes("Manager"),
            [role[0] === "Senior Manager" ? "Senior_Manager" : role[0]]: false,
          })
      );
      setDisable(setVal);
    } else if (role.includes("Admin") && role.length === 1) {
      superVisor.map(
        (row) =>
          (setVal = {
            ...setVal,
            [row]: true,
            Admin: false,
            Operations: false,
            Manager: false,
          })
      );
      setDisable(setVal);
    } else if (role.includes("Senior_Manager")) {
      superVisor.map(
        (row) =>
          (setVal = {
            ...setVal,
            [row]: true,
            Senior_Manager: false,
          })
      );
      setDisable(setVal);
    } else if (role.includes("Finance")) {
      superVisor.map(
        (row) =>
          (setVal = {
            ...setVal,
            [row]: true,
            Finance: false,
          })
      );
      setDisable(setVal);
    } else if (role.includes("BUH")) {
      superVisor.map(
        (row) =>
          (setVal = {
            ...setVal,
            [row]: true,
            BUH: false,
          })
      );
      setDisable(setVal);
    } else if (role.length < 2) {
      superVisor.map((row) => (setVal = { ...setVal, [row]: false }));
      setDisable(setVal);
    } else if (role.includes("Admin") && role.length === 2) {
      superVisor.map(
        (row) =>
          (setVal = {
            ...setVal,
            [row]: true,
            Admin: false,
            [role[1] === "Senior Manager" ? "Senior_Manager" : role[1]]: false,
          })
      );
      setDisable(setVal);
    }
  }

  const { name, email, role, mobile, code, supervisor, state, city } = formVal;

  useEffect(() => {
    manageRole(role);
    getSupervisor(role);
  }, [role]);

  const getData = async (id) => {
    const data = await get_user(id);

    const {
      name,
      code,
      email,
      role,
      supervisor,
      mobile,
      state,
      city,
      designation,
      location,
    } = data.data[0];

    setFormVal({
      ...formVal,
      name,
      code,
      email,
      role: JSON.parse(role),
      supervisor,
      mobile,
      state,
      city,
      location: location != null ? location : "No Location",
      designation: designation != null ? designation : "No Designation",
    });
  };

  async function handleSubmit(e) {
    try {
      e.preventDefault();
      let hasError = false;

      if (role.length < 1) {
        dispatch(
          setAlert({
            open: true,
            type: "error",
            message: "Please Select Role",
          })
        );
        hasError = true;
      }

      // Email validation using a regular expression
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formVal.email)) {
        dispatch(
          setAlert({
            open: true,
            variant: "error",
            message: "Please enter a valid email address",
          })
        );
        hasError = true;
      }

      if (!hasError) {
        const response = await EditUserInfo(id, {
          ...formVal,
          modify: new Date().toISOString().slice(0, 10),
        });

        if (response.status === 200) {
          dispatch(
            setAlert({
              open: true,
              variant: "success",
              message: response.data.message,
            })
          );
          navigate("/userManagement/all-user");
        } else {
          dispatch(
            setAlert({
              open: true,
              variant: "error",
              message: response.data.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        setAlert({
          open: true,
          variant: "error",
          message: "Something Went Wrong! Please Try Again Later.",
        })
      );
    }
  }

  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      const { value, checked } = e.target;

      if (checked) {
        setFormVal({
          ...formVal,
          role: [...role, value],
        });
      } else {
        setFormVal({
          ...formVal,
          role: role.filter((e) => e !== value),
        });
      }
    } else {
      setFormVal({
        ...formVal,
        [e.target.name]: e.target.value,
      });
    }
  };

  useEffect(() => {
    getData(id);
  }, []);

  async function handleStateSearch(e, i) {
    let response = await getStateList(e.target.value);

    if (response.status === 200) {
      setStateList(response.data);
    } else setStateList([]);
  }

  useEffect(() => {
    handleCitySearch();
  }, [state]);

  async function handleCitySearch() {
    let search = stateList.filter((row) => row.name === state && row.id);

    let response = await getCityList(search[0]?.id);

    if (response.status === 200) {
      setCityList(response.data);
    } else setCityList([]);
  }

  const { auth } = useSelector((s) => s);

  return (
    <>
      <Stack sx={{ flexWrap: "nowrap", flexDirection: "row" }}>
        {/* <HamburgerAdmin /> */}
        <SuperAdminHamburgerMenu />

        <Box sx={{ flexGrow: 1 }}>
          <>
            <Grid container sx={{ justifyContent: "center", mt: 2 }}>
              <Grid item xs={12}>
                <Grid
                  item
                  xs={12}
                  sx={{ justifyContent: "space-between", display: "flex" }}
                >
                  <MyHeader>
                    RMS{" "}
                    <span className="small-heading">
                      (Rental Management System)
                    </span>
                  </MyHeader>
                  <Typography mt="15px" mr="15px" fontWeight="600">
                    Welcome {auth.name}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </>
          <Divider />
          <Box className="backButton">
            <IconButton
              variant="contained"
              color="primary"
              onClick={() => navigate(-1)}
              size={"large"}
            >
              <ArrowCircleLeftIcon
                sx={{ fontSize: "3rem" }}
                color="#FFFFF !important"
              />
            </IconButton>
          </Box>
          <Grid
            container
            sx={{
              px: 1,
              justifyContent: "space-between",
              my: 1,
              alignItems: "center",
            }}
          >
            <Grid item xs={6}>
              <Typography
                variant="body1"
                color="black"
                fontSize="20px"
                fontWeight="600"
                alignSelf="center"
                lineHeight="30px"
                sx={{
                  "@media(max-width:600px)": {
                    fontSize: "17px",
                    lineHeight: "25px",
                  },
                }}
              >
                {"View-User Management"}
              </Typography>
            </Grid>
          </Grid>
          <Divider />
          <Grid container sx={{ justifyContent: "center" }}>
            <Grid item>
              <Box
                component="form"
                sx={{
                  py: 5,
                  backgroundColor: "white",
                  mx: 3,
                  borderRadius: "15px",
                  maxWidth: "1050px",
                }}
                onSubmit={handleSubmit}
              >
                <Grid container sx={{ p: 3 }} spacing={4}>
                  <TextFieldWrapper
                    label="Emp.Code"
                    placeHolder=""
                    value={code}
                    onChange={handleChange}
                    required={true}
                    disabled={true}
                    error={formError.code}
                    onBlur={(e) => validate(e)}
                    maxLength={10}
                  />
                  <TextFieldWrapper
                    label="Full Name"
                    placeHolder="Full Name"
                    value={name}
                    name="name"
                    disabled={true}
                    required={true}
                    error={formError.name}
                    onBlur={(e) => validate(e)}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                  <TextFieldWrapper
                    label="Email"
                    placeHolder="Email"
                    value={email}
                    name="email"
                    disabled={true}
                    required={true}
                    onBlur={(e) => validate(e)}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    error={formError.email}
                  />

                  <TextFieldWrapper
                    label="Mobile Number"
                    placeHolder="Mobile Number"
                    value={mobile}
                    name="mobile"
                    maxLength={10}
                    disabled={true}
                    required={true}
                    error={formError.mobile}
                    onBlur={(e) => validate(e)}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                  <Grid
                    item
                    md={4}
                    xs={6}
                    sx={{
                      mb: "0px !important",
                      "@media(max-width:900px)": { my: 1 },
                    }}
                  >
                    <FormControl fullWidth className="textFieldWrapper">
                      <Autocomplete
                        freeSolo
                        fullWidth
                        id="free-solo-2-demo"
                        disabled
                        disableClearable
                        value={state || formVal.state}
                        onChange={(e, val) => {
                          setFormVal((old) => ({ ...old, state: val }));
                        }}
                        options={stateList.map((option) => option.name)}
                        renderInput={(params) => (
                          <TextField
                            fullWidth
                            name="state"
                            disabled={true}
                            value={state || formVal.state}
                            {...params}
                            label="State"
                            required
                            onKeyPress={(e) => {
                              const charCode =
                                e.charCode || e.keyCode || e.which;
                              if (
                                (charCode >= 65 && charCode <= 90) ||
                                (charCode >= 97 && charCode <= 122) ||
                                charCode === 32
                              ) {
                                return;
                              }
                              e.preventDefault();
                            }}
                            onChange={(e) => {
                              setFormVal((prevFormVal) => ({
                                ...prevFormVal,
                                [e.target.name]: e.target.value,
                              }));
                              handleStateSearch(e);
                            }}
                            InputProps={{
                              ...params.InputProps,
                              type: "search",
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>

                  <Grid
                    item
                    md={4}
                    xs={6}
                    sx={{
                      mb: "0px !important",
                      "@media(max-width:900px)": { my: 1 },
                    }}
                  >
                    <FormControl fullWidth className="textFieldWrapper">
                      <TextField
                        label="City"
                        placeHolder="Enter City"
                        select
                        fullWidth
                        name="city"
                        required
                        disabled={true}
                        value={formVal.city || city}
                        onChange={handleChange}
                      >
                        {cityList &&
                          cityList.map((item) => {
                            return (
                              <MenuItem value={item.city}>{item.city}</MenuItem>
                            );
                          })}
                        <MenuItem value={formVal.city}>{formVal.city}</MenuItem>
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={6}
                    sx={{
                      mb: "0px !important",
                      "@media(max-width:900px)": { my: 1 },
                    }}
                  >
                    <FormControl fullWidth className="textFieldWrapper">
                      <TextField
                        label="Supervisor"
                        select
                        fullWidth
                        name={"supervisor"}
                        value={supervisor}
                        disabled={true}
                        onChange={handleChange}
                      >
                        {supervisorArray.map((item, i) => {
                          return (
                            <MenuItem value={item.id} key={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </FormControl>
                  </Grid>
                  <AdminCheckBox
                    handleChange={handleChange}
                    disable={disable}
                    value={role}
                    isSuperAdmin={true}
                  />
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Stack>
    </>
  );
}

export default ViewUser;
